import { assignDefaultValueToObject } from '../../../utility/utility';
import { MobileNavBar } from './layout/mobileNavBar';

let Component = {  MobileNavBar };

export default assignDefaultValueToObject(Component, () => null);
